import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from "../components/message-list";

MessageBroker.subscribe(ProductMessages.CHANGED, ({item, itemOption}) => {
    const params = new URLSearchParams(location.search);
    const pathname = item?.url || location.pathname;

    params.delete('itemOptionId');
    if(itemOption && !item?.singleSize) {
        params.set('itemOptionId', itemOption.id);
    }

    const newSearch = params.toString();
    const newUrl = `${pathname}${newSearch ? `?${newSearch}` : ''}`;
    history.replaceState({}, '', newUrl);
});